import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
export var DifficultyLevelReward = function (_a) {
    var rewardAmount = _a.rewardAmount, rewardResource = _a.rewardResource;
    return (React.createElement(React.Fragment, null,
        React.createElement(ResourceIcon, { resource: rewardResource, styleId: IdStyles.IconExtraLarge }),
        React.createElement("div", { className: "difficulty-reward-amount flex flex--guts " + IdStyles.HappinessContainer },
            React.createElement("span", { className: IdStyles.TextBoldPrimary }, rewardAmount))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/DifficultyLevelReward.tsx
// module id = 2937
// module chunks = 3